<template>
  <div class="col-md-3 sidebar">
    <div class="panel panel-success">
      <div class="panel-heading">Cart Details</div>
      <ul class="list-group">
        <li class="list-group-item">
          Items: <span class="price-is-right">{{ cart.numberOfItems }}</span>
        </li>
        <li class="list-group-item">
          Subtotal:
          <span class="price-is-right">
            ${{ cart.orderTotal }} <small>{{ cart.currency }}</small>
          </span>
        </li>
      </ul>
      <div class="panel-body text-center">
        <a
          href="/checkout"
          class="btn btn-success block767"
          title="Checkout"
          role="button"
        >
          Checkout &raquo;
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../../store/stores";

export default {
  name: "CartDetails",
  store,
  computed: {
    ...mapState(["cart"]),
  },
};
</script>

<style scoped></style>
